/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import {
    ICheckoutTermsAndConditions,
    ICheckoutTermsAndConditionsError,
    ICheckoutTermsAndConditionsViewProps
} from './checkout-terms-and-conditions';

const TermsAndCondition: React.FC<ICheckoutTermsAndConditions> = ({ termsAndConditionAcceptance, checkBox, description }) => {
    return (
        <Node {...termsAndConditionAcceptance}>
            {checkBox}
            {description}
        </Node>
    );
};

const ErrorMessage: React.FC<ICheckoutTermsAndConditionsError> = ({ error, title, message }) => {
    return (
        <Node {...error}>
            {title}
            {message}
        </Node>
    );
};

const CheckoutTermsAndConditionsView: React.FC<ICheckoutTermsAndConditionsViewProps> = props => {
    const {
        checkoutTermsAndConditions,
        checkoutErrorRef,
        viewState,
        termsAndConditionsContent,
        errorMessage,
        saveButton,
        editButton,
        cancelButton
    } = props;

    return (
        // TODO: All wrapper div should be provided by viewProps. Once SDK provide the sln, update markup.
        <Module {...checkoutTermsAndConditions} ref={checkoutErrorRef}>
            {viewState.isError && errorMessage && <ErrorMessage {...errorMessage} />}
            <TermsAndCondition {...termsAndConditionsContent} />
            {viewState.isShowSaveButton && saveButton}
            {viewState.isShowEditButton && editButton}
            {viewState.isShowCancelButton && cancelButton}
        </Module>
    );
};

export default CheckoutTermsAndConditionsView;
